import { inject } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';
import { CoreProvider } from '../core.provider';
import { filter, firstValueFrom } from 'rxjs';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const CUSTOM_REQUEST_AUTHORIZATION = new HttpContextToken<string>(() => '');

export const requireLoggedIn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  if (!core.appIsReady$.value) {
    await firstValueFrom(core.appIsReady$.pipe(filter(v => v === true)));
  }
  const canActivate = core.auth.isAuthenticated ? true : false;
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/login']);
  }
  // console.log('requireLoggedIn', route, state, canActivate, core.appIsReady$.value);
  return canActivate;
};

/**
 * The superadmin screens. Not a security boundary — the API guards
 * `/superadmin/*` with `RoleJwtGuard('SUPER_ADMIN')` — but without this a user
 * who types the URL gets the fleet page and a wall of 403s instead of going
 * where they were headed.
 */
export const requireSuperadmin: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const core = inject(CoreProvider);
  if (!await requireLoggedIn(route, state)) return false;
  if (core.auth.isSuperadmin) return true;
  core.router.navigate(['/']);
  return false;
};

export const requireLogout: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  const canActivate = !await requireLoggedIn(route, state, true);
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/']);
  }
  // console.log('requireLogout', route, state, canActivate);
  return canActivate;
};
